import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { clearError } from '../../actions/error';
import { ClientComponent } from '../../components/ClientComponent';
import { ErrorWrapper, Notification } from '../../components/Notification';
import { ERROR_HIDE_DELAY } from '../../constants/delays';
import { selectError } from '../../selectors/error';

export const ErrorContainer = () => {
  const [isVisible, setIsVisible] = React.useState(false);
  const timeoutRef = React.useRef<number>(undefined);

  const error = useSelector(selectError);
  const dispatch = useDispatch();
  const errorId = error && error.id;

  const closeError = React.useCallback(() => {
    setIsVisible(false);
  }, []);

  const removeError = React.useCallback(() => {
    dispatch(clearError());
  }, []);

  React.useEffect(() => {
    if (errorId) {
      setIsVisible(true);

      timeoutRef.current = window.setTimeout(() => {
        setIsVisible(false);
      }, ERROR_HIDE_DELAY);
    }

    return () => {
      clearTimeout(timeoutRef.current);
    };
  }, [errorId]);

  if (!error) {
    return null;
  }

  return (
    <ClientComponent>
      <ErrorWrapper>
        <Notification
          text={error.message}
          type="error"
          visible={isVisible}
          onClose={closeError}
          onCloseEnd={removeError}
        />
      </ErrorWrapper>
    </ClientComponent>
  );
};
